module["exports"] = [
  "(9##)###-##-##"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/az/phone_number/formats.js
// module id = 75
// module chunks = 0